import * as types from "../types/orderManagement.types";
import {
  getOrderManagementSearchList,
  getOrderManagementDetail,
  putOrderDetailIssues,
  getOrderDetailStatus,
  getOrderUpdateCancelAndCompleteStatus,
  getOrderAssignStory,
  getAssignmentRequests,
  getOrderForceCompletedStatus,
  getOrderManagementnew,
  getOrderDispactherNoteList,
  patchorderDispactherNote,
  getIssuesRequests,
  postReturnPickupOrders,
  UpdateCancelOrderReturnLockService,
  getOrderCancelChargeToRider,
} from "../../services/orderManagement.service";
import { validationErrors } from "../../utils/Helpers";
import { swalNotification } from "../../components/alret/notificztion";

export const getOrderManagementListAction = (data, storeID) => {
  return async (dispatch, getState) => {
    try {
      await getOrderManagementSearchList(
        getState().authReducer.token,
        getState().authReducer.user.id,
        data,
        storeID
      ).then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_ORDER_MANAGEMENT_TASK_LIST_DATA,
            payload: res.data.data,
          });
          dispatch({
            type: types.SET_ORDER_MANAGEMENT_TASK_LIST_PAGINATION_DATA,
            payload: res.data.pagination,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getOrderManagementDetailAction = (data) => {
  return async (dispatch, getState) => {
    // console.log("in getOrderManagementDetailAction")
    try {
      await getOrderManagementDetail(
        data,
        getState().authReducer.token,
        getState().authReducer.user.id
      ).then((res) => {
        // console.log('res.data: ',res.data);
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_ORDER_MANAGEMENT_TASK_DETAIL_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const putOrderDetailIssuesAction = (data) => {
  return async (dispatch, getState) => {
    // console.log("in putOrderDetailIssuesAction")
    try {
      await putOrderDetailIssues(
        data,
        getState().authReducer.token,
        getState().authReducer.user.id
      ).then((res) => {
        // console.log('res.data: ',res.data);
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_ORDER_MANAGEMENT_TASK_ISSUE_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const resetOrdermanagementRequcerAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.RESET_ORDER_MANAGEMENT_REDUCER,
    });
  };
};

export const putStoreIdsFilterAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_STORE_IDS_FILTER,
      payload: data,
    });
  };
};

export const patchStatusMarkAction = (data) => {
  return async (dispatch, getState) => {
    // console.log("in putOrderDetailIssuesAction")
    try {
      await getOrderDetailStatus(
        getState().authReducer.token,
        getState().authReducer.user.id,
        // data
      ).then((res) => {
        // console.log('res.data: ',res.data);
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_STATUS_MARK_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

// update task status by orderId
export const updateOrderStatusAction = (data, message) => {
  return async (dispatch, getState) => {
    try {
      await getOrderUpdateCancelAndCompleteStatus(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        // console.log('res.data: ',res);
        if (res.data.code === 200) {

          if(res.data.data.confirmationCancel === true && data.statusSlug == "cancel"){
              res.data.data.reason = data.reason;
              dispatch({
                type: types.SET_ORDER_CANCEL_CONFIRMATION,
                payload: res.data,
              })

              return true
          }

          swalNotification(
            message,
            res.data.message,
            "success"
          );
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const assignStoryAction = (data) => {
  return async (dispatch, getState) => {
    try {
      return getOrderAssignStory(getState().authReducer.token, getState().authReducer.user.id, data);
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const assignmentRequestsAction = (data, pagi) => {
  return async (dispatch, getState) => {
    try {
      return getAssignmentRequests(getState().authReducer.token, getState().authReducer.user.id, data, pagi);
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const issuesRequestsAction = (data, pagi) => {
  return async (dispatch, getState) => {
    try {
      return getIssuesRequests(getState().authReducer.token, getState().authReducer.user.id, data, pagi);
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const orderForceCompletedStatusAction = (data) => {
  return async (dispatch, getState) => {
    try {
      return getOrderForceCompletedStatus(getState().authReducer.token, getState().authReducer.user.id, data);
    } catch (e) {
      validationErrors(e);
    }
  };
};


export const getOrderManagementAction = (data) => {
  return async (dispatch, getState) => {
    try {
      await getOrderManagementnew(
        getState().authReducer.token,
        getState().authReducer.user.id,
        data
      ).then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_ORDER_MANAGEMENT_TASK_NEW_DATA,
            payload: res.data.data,
          });
          dispatch({
            type: types.SET_ORDER_MANAGEMENT_TASK_NEW_PAGINATION_DATA,
            payload: res.data.pagination,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getOrderFilterAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_ORDER_FILTER,
      payload: data,
    });
  };
};

export const getOrderFilterStoreAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_ORDER_FILTER_STORE,
      payload: data,
    });
  };
};

export const getOrderFilterClickSearchAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_ORDER_FILTER_CLICK_SEARCH,
      payload: data,
    });
  };
};

export const orderDispactherNoteAction = (Oid, data) => {
  return async (dispatch, getState) => {
    try {
      return patchorderDispactherNote(getState().authReducer.token, getState().authReducer.user.id, Oid, data);
    } catch (e) {
      validationErrors(e);
    }
  };
};


export const getReturnPickupOrdersAction = (Oid, data) => {
  return async (dispatch, getState) => {
    try {
      return postReturnPickupOrders(getState().authReducer.token, getState().authReducer.user.id, Oid, data);
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const UpdateCancelOrderReturnLockAction = (data) => {
  return async (dispatch, getState) => {
    // console.log("in getOrderManagementDetailAction")
    // task/canceled-return-status-lock/:orderId
    console.log(data)
    try {
      await UpdateCancelOrderReturnLockService(
        getState().authReducer.token,
        getState().authReducer.user.id,
        data,
      ).then((res) => {
        // console.log('res.data: ',res.data);
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_ORDER_MANAGEMENT_TASK_DETAIL_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

// update task status by orderId
export const updateOrderCancelChargeToRiderAction = (data, message) => {
  return async (dispatch, getState) => {
    try {
      await getOrderCancelChargeToRider(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        if (res.data.code === 200) {
          swalNotification(
            message,
            res.data.message,
            "success"
          );
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};
